import { Box, Button, Fab, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchInputField from '../../../components/fields/SearchInputField';
import useCommonStyles from '../../../useCommonStyles';

export type TagHeaderProps = {
    search: string;
    searchOnChange: (value: string) => void;
    onCreate: () => void;
};

const TagHeader = ({ search, searchOnChange, onCreate }: TagHeaderProps) => {
    const { t } = useTranslation(['tagManagementPage', 'common']);
    const commonStyles = useCommonStyles();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Box alignItems="center" className={commonStyles.title} display="flex">
                {!isSmall && <Typography>{t('tagManagementPage:title')}</Typography>}
                <Box ml="auto" width={isSmall ? '100%' : 'auto'}>
                    <SearchInputField onChange={searchOnChange} placeholder={t('common:search')} value={search} />
                </Box>
                {!isSmall && (
                    <Button color="secondary" onClick={onCreate} size="large" variant="contained">
                        <AddIcon fontSize="small" /> {t('tagManagementPage:create')}
                    </Button>
                )}
            </Box>
            {isSmall && (
                <Box bottom="1rem" position="fixed" right="2rem" zIndex={100}>
                    <Fab aria-label={t('tagManagementPage:create')} color="secondary" onClick={onCreate} size="large">
                        <AddIcon />
                    </Fab>
                </Box>
            )}
        </>
    );
};

export default TagHeader;
